module.exports = __webpack_public_path__ + "static/media/IMG_4045-2.a9726ae4.jpg";